const conditions = () => {
  return [
    { assetClass: { $ne: '' } },
    {
      assetClass: {
        $in: {
          'object.asset-class.options.wohnen': 'object.object-type.searched.options.wohnen',
          'object.asset-class.options.office': 'object.object-type.searched.options.office',
          'object.asset-class.options.handel-retail': 'object.object-type.searched.options.handel-retail',
          'object.asset-class.options.hotel': 'object.object-type.searched.options.hotel',
          'object.asset-class.options.logistik-industrie': 'object.object-type.searched.options.logistik-industrie',
          'object.asset-class.options.healthcare-medical': 'object.object-type.searched.options.healthcare-medical',
          'object.asset-class.options.micro-und-serviced-living': 'object.object-type.searched.options.micro-und-serviced-living',
        },
      },
    },
  ]
}

export default conditions
